import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';

import withComponentName from '../../../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const FilterInner = ({
  options, isSelectAll, handleSelectAll, handleOptionSelect,
}) => (
  <div className={Styles.filter_inner}>
    <div className={Styles.filter_inner_title}>
      Period
    </div>
    <Dropdown.Item eventKey="all_value" active={isSelectAll} onSelect={handleSelectAll}>
      <FontAwesomeIcon icon={isSelectAll ? faCheckSquare : faSquare} />
      <div className={cx('row_title', 'all_option')}>All Periods</div>
    </Dropdown.Item>
    {
      options.map(({
        title, value, select,
      }) => (
        <OptionRow
          key={value}
          name={title}
          value={value}
          select={select}
          onSelect={handleOptionSelect}
        />
      ))
    }
  </div>
);

const OptionRow = ({
  name, value, select, onSelect,
}) => (
  <Dropdown.Item eventKey={value} active={select} onSelect={onSelect}>
    <FontAwesomeIcon icon={select ? faCheckSquare : faSquare} />
    <div className={Styles.row_title}>{name}</div>
  </Dropdown.Item>
);

export default withComponentName(FilterInner);
